import axios from "axios";
import { baseUrl } from "./environment";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useLoading } from "./Loader/LoadingContext";


const axiosInstance = axios.create({
    baseURL: baseUrl
});

// For request


const useAxiosInterceptors = () => {
    const { setLoading } = useLoading();

    useEffect(() => {
    // Request interceptor
    debugger
    const requestInterceptor = axiosInstance.interceptors.request.use((config)=>{
        const token = localStorage.getItem("Token");
        if (token) {
            setLoading(true)
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        return config;
    },(err) => {
        setLoading(false);
        localStorage.clear();
        // window.location.reload()
    });

    const responseInterceptor = axiosInstance.interceptors.response.use((response) => {
        debugger
        setLoading(false);
        if(response.data.status === 201) {
            toast.success("Record Saved Successfully!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
        } else if (response.data.status === 400) {
            toast.error("The request could not be understood or was missing required parameters.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
        }
        else if (response.data.status === 401) {
            toast.error("Your Session is Expired Login Again..!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
    
              localStorage.clear();
            //   window.location.reload()
        }
        else if (response.data.status === 500) {
            toast.error("Internal Server Error.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
        }
        return response;
    },(err) => {
        if (err.status === 401) {
            toast.error("Your Session is Expired Login Again..!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
    
              localStorage.clear();
            //   window.location.reload()
        } else {
            toast.error("Something went wrong plz try again after sometime.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setLoading(false);
        }


    }); 

    // Cleanup function to eject interceptors on unmount
    return () => {
        axiosInstance.interceptors.request.eject(requestInterceptor);
        axiosInstance.interceptors.response.eject(responseInterceptor);
    };

    },[setLoading])
}

// For Response


export { axiosInstance };

export default useAxiosInterceptors;